import { Box, FormGroup, Grid, IconButton, Modal, Typography } from "@mui/material";
import Crossicon from "../../Icon/Crossicon";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import moment from "moment";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import LeftSideArrow from "../../Icon/LeftSideArrow";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  GetStudentAction,
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
} from "../../Redux/action/ApplicationAction";
import {
  AddStudentNotesService,
  DeleteStudentNotesService,
  DeleteStudentReminderService,
  UpdateStudentPinnedService,
} from "../../Redux/service/Application";
import ConfirmationModal from "../Modal/ConfirmationModal/ConfirmationModal";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import CustomButton from "../button/button";
import { Form, Formik } from "formik";
import CustomSelect from "../select field/OutlinedSelectField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "85%", md: "550px" },
  maxHeight: "80vh",
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
  border: "none",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const StudentPinnedModal = ({
  pinnedModal,
  handleClose,
  stdId,
  Studentlist,
  pinned,
  isPinedNotes,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [confirmationopen, setConfirmationOpen] = useState(false);

  const currentStudent = Studentlist?.find(
    (data) => data.id === stdId || data._id === stdId
  );
  const studentName =
    currentStudent?.studentFirstName ||
    currentStudent?.firstName ||
    "";

  return (
    <>
      <Modal
        open={pinnedModal}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              bgcolor: ThemeColor.PURPLE,
              color: "#FFFFFF",
            }}
          >
            <Typography
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W600}
              fontSize={fontSize.h3.medium}
              color="#FFFFFF"
            >
              {studentName ? `Pin Student "${studentName}"` : "Pin Student"}
            </Typography>
            <IconButton
              onClick={() => handleClose()}
              size="small"
              sx={{
                color: "#FFFFFF",
                bgcolor: "rgba(255, 255, 255, 0.15)",
                "&:hover": { bgcolor: "rgba(255, 255, 255, 0.3)" },
              }}
            >
              <Crossicon width={"16"} height={"16"} fill="#FFF" />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
          <Formik
            enableReinitialize={true}
            initialValues={{
              isPined: Boolean(pinned),
              isPinedNotes: isPinedNotes ? isPinedNotes : "",
            }}
            onSubmit={async (values, { resetForm }) => {
              const payload = {
                isPined: values.isPined === true || values.isPined === "true",
                isPinedNotes: values.isPinedNotes || "",
              };

              await UpdateStudentPinnedService(payload, stdId)
                .then((res) => {
                  if (res.status === 200) {
                    dispatch(showSnackbar(res.data.message, "success"));
                    if (onSuccess) {
                      onSuccess({
                        studentId: stdId,
                        isPined: payload.isPined,
                        isPinedNotes: payload.isPinedNotes,
                      });
                    }
                    dispatch(GetStudentAction());
                    handleClose();
                    resetForm();
                  }
                })

                .catch((e) => {
                  dispatch(
                    showSnackbar(
                      e.response?.data?.message || "Failed to update pin status",
                      "error"
                    )
                  );
                });
            }}
          >

            {({
              values,
              errors,
              handleBlur,
              handleChange,
              touched,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form className="d-flex justify-content-center">
                <Box
                  className="addcatalog-container"
                  sx={{
                    width: { sm: "100%", xs: "100%", md: "100%", lg: "100%" },
                  }}
                >
                  <FormGroup style={{}}>
                    <div className="d-flex flex-column align-items-center mt-4">
                      <div className="px-2 w-100">
                        <CustomSelect
                          value={values?.isPined}
                          name={"isPined"}
                          multiple={false}
                          option={[
                            { _id: true, title: "Pin" },
                            { _id: false, title: "Un-pin" },
                          ]}
                          onChange={(e) => {
                            setFieldValue("isPined", e.target.value);
                          }}
                          fullWidth={true}
                          label={"Pinned"}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.isPined}
                            </Typography>
                          }
                        />
                      </div>

                      <div className="px-2 w-100">
                        <OutlinedInputField
                          value={values.isPinedNotes}
                          name={"isPinedNotes"}
                          onChange={handleChange}
                          placeholder="add pinned note text...."
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.isPinedNotes}
                            </Typography>
                          }
                        />
                      </div>
                      <div className="px-3">
                        <CustomButton
                          variant="contained"
                          type="submit"
                          backgroundColor={ThemeColor.PURPLE}
                          color={ThemeColor.WHITE}
                          // loading={formLoading}
                          padding={"0px"}
                        // onClick={handleClick}
                        >
                          Update
                        </CustomButton>
                      </div>
                    </div>
                  </FormGroup>

                  <div className="d-flex justify-content-center align-items-center h-100 w-100 mt-5"></div>
                </Box>
              </Form>
            )}
          </Formik>
          </Box>
        </Box>
      </Modal>
      {/* <ConfirmationModal
        handleConfirmationClose={() => {
          setConfirmationOpen(false);
        }}
        deletefunction={async () => {
          try {
            const res = await DeleteStudentNotesService({ stdId, noteId });

            if (res.status === 200) {
              dispatch(GetStudentNotesByIdAction(stdId)); // Dispatch the action if success
              return res; // Return the result so the child can access it
            } else {
              return Promise.reject("Unexpected response status"); // Handle unexpected status codes
            }
          } catch (e) {
            dispatch(
              showSnackbar(
                e.response?.data?.message || "Error occurred",
                "error"
              )
            );
            return e;
          }
        }}
        confirmationopen={confirmationopen}
        message={"All deleted notes is never been retrievable"}
      /> */}
    </>
  );
};
